export enum Permission {
  // Vehicles
  ViewVehicles = 'ViewVehicles',
  ViewVehicleDetails = 'ViewVehicleDetails',
  EditVehicles = 'EditVehicles',
  CreateVehicle = 'CreateVehicle',
  BulkEditVehicles = 'BulkEditVehicles',
  ExportVehicles = 'ExportVehicles',

  // Containers
  ViewContainers = 'ViewContainers',
  EditContainers = 'EditContainers',
  ViewDamagedContainers = 'ViewDamagedContainers',
  ReportDamagedContainer = 'ReportDamagedContainer',

  // Auto Parts
  ViewAutoparts = 'ViewAutoparts',
  EditAutoparts = 'EditAutoparts',
  ViewDeliveryReceipts = 'ViewDeliveryReceipts',
  CreateDeliveryReceipt = 'CreateDeliveryReceipt',

  // Payments & Storage
  ViewPayments = 'ViewPayments',
  ProcessPayments = 'ProcessPayments',
  EditPayment = 'EditPayment',
  DeletePayment = 'DeletePayment',
  ViewStoragePayments = 'ViewStoragePayments',
  CreateStoragePayment = 'CreateStoragePayment',
  ViewWaivedDays = 'ViewWaivedDays',
  ManageWaivedDays = 'ManageWaivedDays',

  // Reports
  ViewPaymentsReport = 'ViewPaymentsReport',
  ExportPaymentsReport = 'ExportPaymentsReport',
  ViewAmendmentsReport = 'ViewAmendmentsReport',
  ViewDocsCollectedReport = 'ViewDocsCollectedReport',
  ViewNdjChargesReport = 'ViewNdjChargesReport',
  ViewCfPaymentsReport = 'ViewCfPaymentsReport',
  ViewSezFeesReport = 'ViewSezFeesReport',
  ViewWaivedDaysReport = 'ViewWaivedDaysReport',

  // Vessels
  ViewVessels = 'ViewVessels',
  CreateVessel = 'CreateVessel',
  EditVessel = 'EditVessel',
  ViewVesselSchedule = 'ViewVesselSchedule',

  // Notes
  ViewNotes = 'ViewNotes',
  CreateNotes = 'CreateNotes',
  DeleteNotes = 'DeleteNotes',

  // Documents & Uploads
  ViewDocuments = 'ViewDocuments',
  UploadDocuments = 'UploadDocuments',
  UploadCustomerIdScans = 'UploadCustomerIdScans',
  UploadTerminalDocuments = 'UploadTerminalDocuments',
  SendDocuments = 'SendDocuments',

  // Utilities
  ViewExchangeRates = 'ViewExchangeRates',
  ManageExchangeRates = 'ManageExchangeRates',
  ViewNotifications = 'ViewNotifications',
  SendCustomEmail = 'SendCustomEmail',

  // Consignees
  ViewConsignees = 'ViewConsignees',
  EditConsignee = 'EditConsignee',
  DeleteConsignee = 'DeleteConsignee',

  // Calculators
  ViewStorageCalculator = 'ViewStorageCalculator',
  ViewInternalCalculator = 'ViewInternalCalculator',

  // Amendments
  ViewAmendments = 'ViewAmendments',
  CreateAmendment = 'CreateAmendment',

  // Users
  ViewUsers = 'ViewUsers',
  CreateUser = 'CreateUser',
  EditUser = 'EditUser',
  LockUnlockUser = 'LockUnlockUser',
  DeleteUser = 'DeleteUser',
  ManageUserPermissions = 'ManageUserPermissions',

  // Customers
  ViewCustomers = 'ViewCustomers',
  CreateCustomer = 'CreateCustomer',
  EditCustomer = 'EditCustomer',
  DeleteCustomer = 'DeleteCustomer',

  // Consignee Contacts
  ViewConsigneeContacts = 'ViewConsigneeContacts',
  CreateConsigneeContact = 'CreateConsigneeContact',
  EditConsigneeContact = 'EditConsigneeContact',
  DeleteConsigneeContact = 'DeleteConsigneeContact',

  // Authorizations
  ViewAuthorizations = 'ViewAuthorizations',
  CreateAuthorization = 'CreateAuthorization',
  EditAuthorization = 'EditAuthorization',
  DeleteAuthorization = 'DeleteAuthorization',
}

export const PermissionGroups: {
  group: string;
  permissions: { value: Permission; label: string }[];
}[] = [
  {
    group: 'Vehicles',
    permissions: [
      { value: Permission.ViewVehicles, label: 'View Vehicles' },
      { value: Permission.ViewVehicleDetails, label: 'View Vehicle Details' },
      { value: Permission.EditVehicles, label: 'Edit Vehicles' },
      { value: Permission.CreateVehicle, label: 'Create Vehicle' },
      { value: Permission.BulkEditVehicles, label: 'Bulk Edit Vehicles' },
      { value: Permission.ExportVehicles, label: 'Export Vehicles' },
    ],
  },
  {
    group: 'Containers',
    permissions: [
      { value: Permission.ViewContainers, label: 'View Containers' },
      { value: Permission.EditContainers, label: 'Edit Containers' },
      {
        value: Permission.ViewDamagedContainers,
        label: 'View Damaged Containers',
      },
      {
        value: Permission.ReportDamagedContainer,
        label: 'Report Damaged Container',
      },
    ],
  },
  {
    group: 'Auto Parts',
    permissions: [
      { value: Permission.ViewAutoparts, label: 'View Auto Parts' },
      { value: Permission.EditAutoparts, label: 'Edit Auto Parts' },
      {
        value: Permission.ViewDeliveryReceipts,
        label: 'View Delivery Receipts',
      },
      {
        value: Permission.CreateDeliveryReceipt,
        label: 'Create Delivery Receipt',
      },
    ],
  },
  {
    group: 'Payments & Storage',
    permissions: [
      { value: Permission.ViewPayments, label: 'View Payments' },
      { value: Permission.ProcessPayments, label: 'Process Payments' },
      { value: Permission.EditPayment, label: 'Edit Payment' },
      { value: Permission.DeletePayment, label: 'Delete Payment' },
      { value: Permission.ViewStoragePayments, label: 'View Storage Payments' },
      {
        value: Permission.CreateStoragePayment,
        label: 'Create Storage Payment',
      },
      { value: Permission.ViewWaivedDays, label: 'View Waived Days' },
      { value: Permission.ManageWaivedDays, label: 'Manage Waived Days' },
    ],
  },
  {
    group: 'Reports',
    permissions: [
      { value: Permission.ViewPaymentsReport, label: 'View Payments Report' },
      {
        value: Permission.ExportPaymentsReport,
        label: 'Export Payments Report',
      },
      {
        value: Permission.ViewAmendmentsReport,
        label: 'View Amendments Report',
      },
      {
        value: Permission.ViewDocsCollectedReport,
        label: 'View Docs Collected Report',
      },
      {
        value: Permission.ViewNdjChargesReport,
        label: 'View NDJ Charges Report',
      },
      {
        value: Permission.ViewCfPaymentsReport,
        label: 'View C&F Payments Report',
      },
      { value: Permission.ViewSezFeesReport, label: 'View SEZ Fees Report' },
      {
        value: Permission.ViewWaivedDaysReport,
        label: 'View Waived Days Report',
      },
    ],
  },
  {
    group: 'Vessels',
    permissions: [
      { value: Permission.ViewVessels, label: 'View Vessels' },
      { value: Permission.CreateVessel, label: 'Create Vessel' },
      { value: Permission.EditVessel, label: 'Edit Vessel' },
      { value: Permission.ViewVesselSchedule, label: 'View Vessel Schedule' },
    ],
  },
  {
    group: 'Notes',
    permissions: [
      { value: Permission.ViewNotes, label: 'View Notes' },
      { value: Permission.CreateNotes, label: 'Create Notes' },
      { value: Permission.DeleteNotes, label: 'Delete Notes' },
    ],
  },
  {
    group: 'Documents & Uploads',
    permissions: [
      { value: Permission.ViewDocuments, label: 'View Documents' },
      { value: Permission.UploadDocuments, label: 'Upload Documents' },
      {
        value: Permission.UploadCustomerIdScans,
        label: 'Upload Customer ID Scans',
      },
      {
        value: Permission.UploadTerminalDocuments,
        label: 'Upload Terminal Documents',
      },
      { value: Permission.SendDocuments, label: 'Send Documents' },
    ],
  },
  {
    group: 'Utilities',
    permissions: [
      { value: Permission.ViewExchangeRates, label: 'View Exchange Rates' },
      { value: Permission.ManageExchangeRates, label: 'Manage Exchange Rates' },
      { value: Permission.ViewNotifications, label: 'View Notifications' },
      { value: Permission.SendCustomEmail, label: 'Send Custom Email' },
    ],
  },
  {
    group: 'Consignees',
    permissions: [
      { value: Permission.ViewConsignees, label: 'View Consignees' },
      { value: Permission.EditConsignee, label: 'Edit Consignee' },
      { value: Permission.DeleteConsignee, label: 'Delete Consignee' },
    ],
  },
  {
    group: 'Calculators',
    permissions: [
      {
        value: Permission.ViewStorageCalculator,
        label: 'View Storage Calculator',
      },
      {
        value: Permission.ViewInternalCalculator,
        label: 'View Internal Calculator',
      },
    ],
  },
  {
    group: 'Amendments',
    permissions: [
      { value: Permission.ViewAmendments, label: 'View Amendments' },
      { value: Permission.CreateAmendment, label: 'Create Amendment' },
    ],
  },
  {
    group: 'Users',
    permissions: [
      { value: Permission.ViewUsers, label: 'View Users' },
      { value: Permission.CreateUser, label: 'Create User' },
      { value: Permission.EditUser, label: 'Edit User' },
      { value: Permission.LockUnlockUser, label: 'Lock / Unlock User' },
      { value: Permission.DeleteUser, label: 'Delete User' },
      {
        value: Permission.ManageUserPermissions,
        label: 'Manage User Permissions',
      },
    ],
  },
  {
    group: 'Customers',
    permissions: [
      { value: Permission.ViewCustomers, label: 'View Customers' },
      { value: Permission.CreateCustomer, label: 'Create Customer' },
      { value: Permission.EditCustomer, label: 'Edit Customer' },
      { value: Permission.DeleteCustomer, label: 'Delete Customer' },
    ],
  },
  {
    group: 'Consignee Contacts',
    permissions: [
      {
        value: Permission.ViewConsigneeContacts,
        label: 'View Consignee Contacts',
      },
      {
        value: Permission.CreateConsigneeContact,
        label: 'Create Consignee Contact',
      },
      {
        value: Permission.EditConsigneeContact,
        label: 'Edit Consignee Contact',
      },
      {
        value: Permission.DeleteConsigneeContact,
        label: 'Delete Consignee Contact',
      },
    ],
  },
  {
    group: 'Authorizations',
    permissions: [
      { value: Permission.ViewAuthorizations, label: 'View Authorizations' },
      {
        value: Permission.CreateAuthorization,
        label: 'Create Authorization',
      },
      { value: Permission.EditAuthorization, label: 'Edit Authorization' },
      {
        value: Permission.DeleteAuthorization,
        label: 'Delete Authorization',
      },
    ],
  },
];
